import Cookies from 'js-cookie';

const getSalesForceId = () => {
  const cookieValue = Cookies.get('LeadSourceNewCookie');
  if (!cookieValue) return null;

  try {
    const parsedCookieValue = JSON.parse(cookieValue);
    return parsedCookieValue?.lead_sf_campaignid ?? null;
  } catch (error) {
    console.error('Failed to parse cookie value:', error);
    return null;
  }
};

export default getSalesForceId;
